module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-left-top-stone-path-background-remnants.830188fd.png";